import { createSlice } from "@reduxjs/toolkit";
// utils
import axios from "../../utils/axios";
//
import { dispatch } from "../store";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  countries: [],
  currencies: [],
  genres: [],
  maritals: [],
  usertypeids: [],
  typetransactions: [],
  users: [],
  operators: [],
  providers: [],
  appreport: null,
  appticketreport: null,
  transactions: [],
};

const slice = createSlice({
  name: "generale",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET COUNTRIES
    getCountriesSuccess(state, action) {
      state.isLoading = false;
      state.countries = action.payload;
    },

    // GET CURRENCIES
    getCurrenciesSuccess(state, action) {
      state.isLoading = false;
      state.currencies = action.payload;
    },

    // GET GENRES
    getGenresSuccess(state, action) {
      state.isLoading = false;
      state.genres = action.payload;
    },

    // GET MARITALS
    getMaritalsSuccess(state, action) {
      state.isLoading = false;
      state.maritals = action.payload;
    },

    // GET TYPEIDS
    getTypeIdsSuccess(state, action) {
      state.isLoading = false;
      state.usertypeids = action.payload;
    },

    // GET TYPETRANSACTIONS
    getTypeTransactionsSuccess(state, action) {
      state.isLoading = false;
      state.typetransactions = action.payload;
    },

    // GET APP REPORT
    getAppReportsSuccess(state, action) {
      state.isLoading = false;
      state.appreport = action.payload;
    },

    // GET APP TICKET REPORT
    getAppTicketReportsSuccess(state, action) {
      state.isLoading = false;
      state.appticketreport = action.payload;
    },

    // GET USERS
    getUsersSuccess(state, action) {
      state.isLoading = false;
      state.users = action.payload;
    },
    // GET OPERATORS
    getOperatorsSuccess(state, action) {
      state.isLoading = false;
      state.operators = action.payload;
    },
    // GET PROVIDERS
    getProvidersSuccess(state, action) {
      state.isLoading = false;
      state.providers = action.payload;
    },
    // GET TRANSACTIONS
    getTransactionsSuccess(state, action) {
      state.isLoading = false;
      state.transactions = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function getCountries() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get("/api/v1/countries");
      dispatch(slice.actions.getCountriesSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getCurrencies() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get("/api/v1/currencies");
      dispatch(slice.actions.getCurrenciesSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getGenres() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get("/api/v1/genres");
      dispatch(slice.actions.getGenresSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getMaritals() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get("/api/v1/maritals");
      dispatch(slice.actions.getMaritalsSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getTypeIds() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get("/api/v1/typeids");
      dispatch(slice.actions.getTypeIdsSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getTypeTransactions() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get("/api/v1/typetransactions");
      dispatch(slice.actions.getTypeTransactionsSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getAppReport() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const appCurrency = localStorage.getItem("app-currency");
      const selectedCurrency =
        appCurrency && !["null", "undefined", ""].includes(appCurrency)
          ? appCurrency
          : null;
      const query = selectedCurrency ? `?currency=${selectedCurrency}` : "";
      const response = await axios.get(
        `/api/v1/dashboard-agent/app-report${query}`
      );
      dispatch(slice.actions.getAppReportsSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getAppTicketReport() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(
        "/api/v1/dashboard-agent/app-ticket-report"
      );
      dispatch(slice.actions.getAppTicketReportsSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// Agents-to-select endpoint not available in agent portal (supervisor-only)
// export function getUsers() {
//   return async () => {
//     dispatch(slice.actions.startLoading());
//     try {
//       const response = await axios.get(
//         "/api/v1/dashboard-agent/agents-to-select"
//       );
//       dispatch(slice.actions.getUsersSuccess(response.data));
//     } catch (error) {
//       dispatch(slice.actions.hasError(error));
//     }
//   };
// }

// Operators endpoint not available in agent portal (admin-level)
// export function getOperators() {
//   return async () => {
//     dispatch(slice.actions.startLoading());
//     try {
//       const response = await axios.get(
//         "/api/v1/dashboard-agent/operators"
//       );
//       dispatch(slice.actions.getOperatorsSuccess(response.data));
//     } catch (error) {
//       dispatch(slice.actions.hasError(error));
//     }
//   };
// }

export function getProviders() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get("/api/v1/providers");
      dispatch(slice.actions.getProvidersSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getTransactions(
  page = 1,
  rowsPerPage = 5,
  filterStartDate,
  filterEndDate,
  filterUser,
  filterName
) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const appCurrency = localStorage.getItem("app-currency");
      const selectedCurrency =
        appCurrency && !["null", "undefined", ""].includes(appCurrency)
          ? appCurrency
          : "";
      const response = await axios.get(
        `/api/v1/dashboard-agent/transactions?page=${page}&page_size=${rowsPerPage}&start_date=${filterStartDate}&end_date=${filterEndDate}&user=${filterUser}&ref_code=${filterName}&currency=${selectedCurrency}`
      );
      dispatch(slice.actions.getTransactionsSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
